// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3nY2M";
var _3 = "additional_class-1QO6f";
var _4 = "checked-2vDd0";
var _5 = "disabled-2gGxs";
export { _1 as "__esModule", _2 as "root", _3 as "additional_class", _4 as "checked", _5 as "disabled" }
export default { "__esModule": _1, "root": _2, "additional_class": _3, "checked": _4, "disabled": _5 }
